var _polygon, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.6 24.6",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Attention") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "exclaimationHWA0",
    points: "17 0.9 8.5 3 3.2 8.7 3.2 16.9 8.5 22.1 17.6 23.5 17 24 7.8 24 0.9 16.9 0.9 7.7 7.3 0.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "exclaimationHWA1",
    cx: 12.4,
    cy: 18.2,
    r: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "exclaimationHWA1",
    d: "m12.8 5.2c0.5 0 0.9 0.4 0.9 0.9l-0.3 9c0 0.5-0.4 0.9-0.9 0.9h-0.3c-0.5 0-0.9-0.4-0.9-0.9l-0.4-9c0-0.5 0.4-0.9 0.9-0.9h1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "exclaimationHWA2",
    d: "m16.9 1.2l6.5 6.5v9.2l-6.5 6.5h-9.2l-6.5-6.5v-9.2l6.5-6.5h9.2m0.5-1.2h-10.2l-7.2 7.2v10.2l7.2 7.2h10.2l7.2-7.2v-10.2l-7.2-7.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.5a6ee7251ead6f80b6954d98110dd754.svg";
export { ForwardRef as ReactComponent };